// @todo: Migrate to 'Button' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {WBButton} from '@wandb/weave/common/components/elements/WBButtonNew';
import * as globals from '@wandb/weave/common/css/globals.styles';
// eslint-disable-next-line wandb/no-deprecated-imports
import {
  Input as SemanticInput,
  Modal as SemanticModal,
} from 'semantic-ui-react';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const Modal = styled(SemanticModal)`
  padding: 32px;
  max-width: 500px;
`;

export const Header = styled.div`
  font-size: 24px;
  font-weight: 600;
  color: ${globals.TEXT_PRIMARY_COLOR};
`;

export const Fields = styled.div`
  margin-top: 32px;
`;

export const Field = styled.div`
  margin-top: 20px;
`;

export const Label = styled.label`
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: ${globals.MOON_650};
`;

export const Input = styled(SemanticInput)`
  margin-top: 8px;
  width: 100%;
  &&&&& input {
    padding: 8px 12px;
    border-color: ${globals.MOON_250};
    &::placeholder {
      color: ${globals.MOON_500};
    }
  }
`;

export const Actions = styled.div`
  margin-top: 32px;
`;

export const ConfirmButton = styled(WBButton).attrs({
  variant: `confirm`,
  size: `medium`,
})`
  &&&&& {
    margin-right: 10px;
  }
`;

export const CancelButton = styled(WBButton).attrs({
  variant: `ghost`,
  size: `medium`,
})`
  &&&&& {
  }
`;
